import React, { useState } from "react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { useGetCustomerDetailsById } from "../../hooks";
import {
  DataRateContainer,
  DialogButton,
  HubButtonGroupSlider,
  HubCardStack,
} from "../../components";

import { StyledDataStack } from "./styles";
import { getAction, tabs } from "./helper";

const ContactContent = () => {
  const { id } = useParams();
  const { data: customer } = useGetCustomerDetailsById(id);

  const [value, setValue] = useState(tabs[0].id);
  const index = tabs.findIndex((tab) => tab.id === value);

  const hasParts = !!customer?.hasParts;
  const isVendor = !!customer?.isVendor;
  const revenue = customer?.revenue || [];

  const action = getAction(value, { hasParts, isVendor });

  return (
    <Stack width="100%" padding="15px" gap="15px" overflow="clip auto">
      <StyledDataStack>
        {revenue.map((data, i) => (
          <DataRateContainer key={i} {...data} />
        ))}
      </StyledDataStack>
      <HubCardStack padding="15px" gap="15px" height="100%" overflow="hidden">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HubButtonGroupSlider
            buttons={tabs}
            selected={value}
            setSelected={setValue}
            sx={{ width: "fit-content" }}
          />
          {action && (
            <DialogButton variant="contained" size="xsmall" {...action} />
          )}
        </Stack>
        {index !== -1 && tabs[index].view}
      </HubCardStack>
    </Stack>
  );
};

export default ContactContent;
